export default __webpack_public_path__ + "721d16c7aa2a5671d4428fbf8e1aa253.png";